/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const reportOverviewLinksDtoSchema = z.object({
  website: z.optional(z.string()),
  linkedin: z.optional(z.string()),
  demo: z.optional(z.string()),
});
